import React from "react";
import { HeaderBase, HeaderTypes } from "./PageHeaderBase";

export const ProjectInsightsHeader = () => {
  return (
    <HeaderBase
      variant={HeaderTypes.PROJECT}
      title="Project insights"
      subtitle="Everything you need on the projects you support"
    />
  );
};

export type AccountPagesHeaderProps = {
  title: string;
  subtitle?: string;
};

export const AccountPagesHeader = ({
  title,
  subtitle,
}: AccountPagesHeaderProps) => {
  return (
    <HeaderBase
      variant={HeaderTypes.ACCOUNT}
      title={title}
      subtitle={subtitle}
    />
  );
};

export interface BadgesPageHeaderProps {
  fullNamePlural: string;
  isOwnProfile: boolean;
}

export const BadgesPageHeader = ({
  fullNamePlural,
  isOwnProfile,
}: BadgesPageHeaderProps) => {
  return (
    <HeaderBase
      variant={HeaderTypes.BADGES}
      title="Badges"
      subtitle={`${isOwnProfile ? "Your" : fullNamePlural}
       personal climate contributions`}
    />
  );
};
